/** Sous-étapes de l'étape Finitions (cartes dépliables). */
export enum FinishesSubStep {
  None = 0,
  Doors = 1,
  Colors = 2,
  Finishes = 3,
}
